export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "Absolutne": "Absolut",
        "Adres": "Adresse",
        "Adres email": "E-Mail-Adresse",
        "Ai": "KI",
        "Akcje warstwy": "Ebenenaktionen",
        "Akcje widgetu": "Widget-Aktionen",
        "Aktualna karta": "Aktuelle Registerkarte",
        "Aktualne selektory dla których wyświetlane i edytowane są style": "Aktuelle Selektoren, für die Stile angezeigt und bearbeitet werden",
        "Aktywne": "Aktiv",
        "Angielski": "Englisch",
        "Animacja elementu": "Elementanimation",
        "Animacje": "Animationen",
        "Anuluj": "Abbrechen",
        "Arkusz styli": "Stylesheet",
        "Arkusze styli": "Stylesheets",
        "Auto": "Auto",
        "Automatyczna": "Automatisch",
        "Automatyczne odtwarzanie": "Automatische Wiedergabe",
        "Bez limitu": "Unbegrenzt",
        "Biblioteka": "Bibliothek",
        "Błąd podczas dodawania urządzenia": "Fehler beim Hinzufügen des Geräts",
        "Błędna szerokość": "Ungültige Breite",
        "Blur": "Unschärfe",
        "brak": "keine",
        "Brak": "Keine",
        "Brak animacji": "Keine Animation",
        "Brak elementów pasujących do wyszukiwania.": "Keine passenden Elemente gefunden.",
        "Brak limitu": "Kein Limit",
        "Brak szablonów.": "Keine Vorlagen.",
        "Brak widgetów pasujących do wyszukiwania.": "Keine passenden Widgets gefunden.",
        "Brak zawartości strony": "Kein Seiteninhalt",
        "Cały tekst małą literą": "Gesamten Text in Kleinbuchstaben",
        "Cały tekst wielką literą": "Gesamten Text in Großbuchstaben",
        "Checkbox": "Kontrollkästchen",
        "Cień": "Schatten",
        "Cofnij": "Rückgängig",
        "CSS": "CSS",
        "Cytat": "Zitat",
        "Czas trwania": "Dauer",
        "Czas trwania (ms)": "Dauer (ms)",
        "Czas trwania zmiany styli (transition)": "Dauer der Stiländerung (Transition)",
        "Czcionka": "Schriftart",
        "Czcionki": "Schriftarten",
        "Czy na pewno chcesz usunąć to urządzenie?": "Möchten Sie dieses Gerät wirklich löschen?",
        "Dekoracja": "Dekoration",
        "Do lewej": "Links",
        "Do prawej": "Rechts",
        "Dodaj": "Hinzufügen",
        "Dodaj element": "Element hinzufügen",
        "Dodaj klasę": "Klasse hinzufügen",
        "Dodaj kolejną klasę": "Weitere Klasse hinzufügen",
        "Dodaj kolejną opcję": "Weitere Option hinzufügen",
        "Dodaj kolejny arkusz styli": "Weiteres Stylesheet hinzufügen",
        "Dodaj kolejny skrypt": "Weiteres Skript hinzufügen",
        "Dodaj kolor": "Farbe hinzufügen",
        "Dodaj niestandardowe urządzenie": "Benutzerdefiniertes Gerät hinzufügen",
        "Dodaj nowy element listy": "Neues Listenelement hinzufügen",
        "Dodaj nowy slajd": "Neue Folie hinzufügen",
        "Dodaj szablon": "Vorlage hinzufügen",
        "Dodaj warstwę": "Ebene hinzufügen",
        "Dodatkowy element": "Zusätzliches Element",
        "Dolny": "Unten",
        "Domyślny": "Standard",
        "Dostępne klasy": "Verfügbare Klassen",
        "Duplikuj": "Duplizieren",
        "Duży komputer": "Großer Computer",
        "Duży telefon": "Großes Smartphone",
        "Dwie kolumny w wierszu": "Zwei Spalten pro Zeile",
        "Dziedziczona": "Geerbt",
        "ease": "ease",
        "ease-in": "ease-in",
        "ease-in-out": "ease-in-out",
        "ease-out": "ease-out",
        "Edycja": "Bearbeiten",
        "Edytor kodu CSS": "CSS-Code-Editor",
        "Edytor kodu HTML": "HTML-Code-Editor",
        "Edytor kodu JavaScript": "JavaScript-Code-Editor",
        "Edytor kodu Vue": "Vue-Code-Editor",
        "Edytor komponentu React": "React-Komponenten-Editor",
        "Edytuj": "Bearbeiten",
        "Edytuj kod CSS": "CSS-Code bearbeiten",
        "Edytuj kod HTML": "HTML-Code bearbeiten",
        "Edytuj kod JavaScript": "JavaScript-Code bearbeiten",
        "Edytuj kod Vue": "Vue-Code bearbeiten",
        "Edytuj komponent React": "React-Komponente bearbeiten",
        "Edytuj style": "Stile bearbeiten",
        "Edytuj szablon": "Vorlage bearbeiten",
        "Efekty": "Effekte",
        "Eksportuj stronę": "Seite exportieren",
        "Eksportuj widget": "Widget exportieren",
        "Element {name}": "Element {name}",
        "Element klikalny": "Anklickbares Element",
        "Element listy": "Listenelement",
        "Elementy": "Elemente",
        "Etykieta": "Beschriftung",
        "Film": "Video",
        "Film YouTube": "YouTube-Video",
        "Filtr": "Filter",
        "Filtr tła": "Hintergrundfilter",
        "Flex": "Flex",
        "Formularz": "Formular",
        "Francuski": "Französisch",
        "Funkcja": "Funktion",
        "Generuj tekst": "Text generieren",
        "Globalna klasa": "Globale Klasse",
        "Globalne kolory": "Globale Farben",
        "Górny": "Oben",
        "Gradient": "Verlauf",
        "Gradient promieniowy": "Radialer Verlauf",
        "Grid": "Grid",
        "Gruba": "Fett",
        "Grubość obramowania": "Rahmenstärke",
        "Grubość tekstu": "Schriftstärke",
        "Historia edycji": "Bearbeitungsverlauf",
        "Hover": "Hover",
        "Id inputa": "Input-ID",
        "Ikona": "Symbol",
        "Importuj stronę": "Seite importieren",
        "Importuj widget": "Widget importieren",
        "Indeksowanie": "Indexierung",
        "Indeksuj": "Indexieren",
        "Indykatory": "Indikatoren",
        "Indykatory poza sliderem": "Indikatoren außerhalb des Sliders",
        "Italic": "Kursiv",
        "Jasność": "Helligkeit",
        "Jedna wartość": "Ein Wert",
        "Jednostka": "Einheit",
        "Język": "Sprache",
        "Klasy": "Klassen",
        "Kod": "Code",
        "Kod nie może być pusty": "Der Code darf nicht leer sein",
        "Kod skopiowany.": "Code kopiert.",
        "Kod strony": "Seiten-Code",
        "Kod svg": "SVG-Code",
        "Koło": "Kreis",
        "Kolor": "Farbe",
        "Kolor obramowania": "Rahmenfarbe",
        "Kolor strzałek": "Pfeilfarbe",
        "Kolor tekstu": "Textfarbe",
        "Kolor wypełnienia indykatorów": "Füllfarbe der Indikatoren",
        "Kolory": "Farben",
        "Kolumna": "Spalte",
        "Kolumny": "Spalten",
        "Komputer": "Computer",
        "Konfiguracja": "Konfiguration",
        "Kontener": "Container",
        "Kontrast": "Kontrast",
        "Kontrolki playera": "Player-Steuerung",
        "Kopiuj": "Kopieren",
        "Kreator stron": "Website-Baukasten",
        "Krok": "Schritt",
        "Kursor": "Cursor",
        "Kwadrat": "Quadrat",
        "Label": "Beschriftung",
        "Label dla inputa": "Beschriftung für das Eingabefeld",
        "Laptop": "Laptop",
        "Lepkie": "Sticky",
        "Lewy": "Links",
        "Lewy dolny": "Links unten",
        "Lewy dolny róg": "Linke untere Ecke",
        "Lewy górny": "Links oben",
        "Lewy górny róg": "Linke obere Ecke",
        "Liczba widocznych slajdów": "Anzahl sichtbarer Folien",
        "Liczby dziesiętne": "Dezimalzahlen",
        "Liczby rzymskie": "Römische Zahlen",
        "linear": "linear",
        "Linia ciągła": "Durchgezogene Linie",
        "Linia kropkowana": "Gepunktete Linie",
        "Linia u dołu tekstu": "Linie unter dem Text",
        "Linia u góry tekstu": "Linie über dem Text",
        "Linia wycentrowana": "Zentrierte Linie",
        "Link": "Link",
        "Link do filmu YouTube": "YouTube-Videolink",
        "LinkBox": "LinkBox",
        "Lista": "Liste",
        "Lista nienumerowana": "Ungeordnete Liste",
        "Lista numerowana": "Nummerierte Liste",
        "Maks. szerokość": "Max. Breite",
        "Maks. wysokość": "Max. Höhe",
        "Maksymalna szerokość": "Maximale Breite",
        "Maksymalna szerokość w px": "Maximale Breite in px",
        "Mały tablet": "Kleines Tablet",
        "Mały telefon": "Kleines Smartphone",
        "Mapa": "Karte",
        "Margines": "Außenabstand",
        "Menadżer urządzeń": "Geräte-Manager",
        "Metoda": "Methode",
        "Min. szerokość": "Min. Breite",
        "Min. wysokość": "Min. Höhe",
        "Motywy": "Designs",
        "Nagłówek": "Überschrift",
        "Nagłówek 1": "Überschrift 1",
        "Nagłówek 2": "Überschrift 2",
        "Nagłówek 3": "Überschrift 3",
        "Nagłówek 4": "Überschrift 4",
        "Nagłówek 5": "Überschrift 5",
        "Narzędzia AI": "KI-Tools",
        "Narzędzia kreatora": "Baukasten-Tools",
        "Narzędzia strony": "Seitentools",
        "Następny slajd": "Nächste Folie",
        "Nawigacja": "Navigation",
        "Nazwa": "Name",
        "Nazwa klasy": "Klassenname",
        "Nazwa koloru": "Farbname",
        "Nazwa koloru jest wymagana": "Farbname ist erforderlich",
        "Nazwa koloru już istnieje": "Farbname ist bereits vorhanden",
        "Nazwa musi mieć minimum 2 znaki": "Der Name muss mindestens 2 Zeichen lang sein",
        "Nazwa nie może być pusta": "Der Name darf nicht leer sein",
        "Nazwa skryptu": "Skriptname",
        "Nazwa szablonu": "Vorlagenname",
        "Nazwa urządzenia": "Gerätename",
        "Nazwa warstwy": "Ebenenname",
        "Nie indeksuj": "Nicht indexieren",
        "Nie posiadasz uprawnień aby zaimportować komponent": "Sie haben keine Berechtigung, eine Komponente zu importieren",
        "Nie posiadasz uprawnień aby zapisać komponent": "Sie haben keine Berechtigung, eine Komponente zu speichern",
        "Nie posiadasz uprawnień do dodania nowego motywu": "Sie haben keine Berechtigung, ein neues Theme hinzuzufügen",
        "Nie posiadasz uprawnień do edycji zapisanego komponentu": "Sie haben keine Berechtigung, eine gespeicherte Komponente zu bearbeiten",
        "Nie posiadasz uprawnień do usunięcia motywu": "Sie haben keine Berechtigung, ein Theme zu löschen",
        "Nie posiadasz uprawnień do usunięcia zapisanego komponentu": "Sie haben keine Berechtigung, eine gespeicherte Komponente zu löschen",
        "Nie powtarzaj": "Nicht wiederholen",
        "Nie udało się pobrać definicji widgetu": "Widget-Definition konnte nicht abgerufen werden",
        "Nie udało się pobrać szablonów": "Vorlagen konnten nicht abgerufen werden",
        "Nie udało się pobrać widgetów": "Widgets konnten nicht abgerufen werden",
        "Nie udało się skopiować kodu.": "Code konnte nicht kopiert werden.",
        "Nie udało się usunąć szablonu.": "Vorlage konnte nicht gelöscht werden.",
        "Nie udało się wczytać widgetu.": "Widget konnte nicht geladen werden.",
        "Nie udało się wygenerować tekstu": "Text konnte nicht generiert werden",
        "Nie udało się zaimportować widgetu": "Widget konnte nicht importiert werden",
        "Nie udało się zaktualizować widgetu": "Widget konnte nicht aktualisiert werden",
        "Nie udało się zapisać widgetu": "Widget konnte nicht gespeichert werden",
        "Nie wyświetlaj": "Nicht anzeigen",
        "Nie zawijaj": "Nicht umbrechen",
        "Niemiecki": "Deutsch",
        "Nienumerowana": "Unnummeriert",
        "Nieparzysty element": "Ungerades Element",
        "Nieprawidłowy format koloru": "Ungültiges Farbformat",
        "Nieruchome": "Fest",
        "Niestandardowe": "Benutzerdefiniert",
        "Normalna": "Normal",
        "Nowa karta": "Neuer Tab",
        "np. checkbox-1": "z. B. checkbox-1",
        "np. https://ideo.pl": "z. B. https://ideo.pl",
        "np. Jan": "z. B. Jan",
        "np. Nad przyrwą 13": "z. B. Nad przyrwą 13",
        "np. radio-1": "z. B. radio-1",
        "np. Tekst opisowy": "z. B. Beschreibungstext",
        "np. Twoje imie": "z. B. Ihr Name",
        "Numerowana": "Nummeriert",
        "Obetnij nadmiar": "Überschüssiges abschneiden",
        "Obramowanie": "Rahmen",
        "Obrót odcieni": "Farbtonrotation",
        "Odblokuj": "Entsperren",
        "Odepnij": "Lösen",
        "Odległość między elementami": "Abstand zwischen Elementen",
        "Odległość między slajdami (px)": "Abstand zwischen Folien (px)",
        "Odległość od dolnej krawędzi": "Abstand zum unteren Rand",
        "Odległość od górnej krawędzi": "Abstand zum oberen Rand",
        "Odległość z lewej strony": "Abstand von links",
        "Odległość z prawej strony": "Abstand von rechts",
        "Odstęp dookoła elementów": "Abstand rund um die Elemente",
        "Odstęp pomiędzy elementami": "Abstand zwischen den Elementen",
        "Odwrócenie": "Umkehrung",
        "Odziedzoczono po": "Geerbt von",
        "Offset x": "Versatz X",
        "Offset Y": "Versatz Y",
        "Opcje": "Optionen",
        "Opis dla open graph": "Open-Graph-Beschreibung",
        "Opis strony": "Seitenbeschreibung",
        "Opóźnienie (ms)": "Verzögerung (ms)",
        "Osobno dla boków": "Für jede Seite einzeln",
        "Ostatnie kolory": "Letzte Farben",
        "Otwórz kreator stron": "Seiteneditor öffnen",
        "Padający cień": "Schlagschatten",
        "Padding": "Innenabstand",
        "Page builder": "Seiteneditor",
        "Page Builder": "Seiteneditor",
        "Paragraf": "Absatz",
        "Parzysty element": "Gerades Element",
        "Pasek progresu": "Fortschrittsbalken",
        "Podaj szerokość w px": "Breite in px angeben",
        "Podany kod jest niepoprawny, w konsoli znajdują się informacje o błędach": "Der eingegebene Code ist ungültig. Weitere Informationen zu den Fehlern finden Sie in der Konsole",
        "Podgląd": "Vorschau",
        "Podkreślenie": "Unterstreichen",
        "Podpowiedź": "Hinweis",
        "Pogrubienie": "Fett",
        "Pojedyńcza kolumna": "Einzelne Spalte",
        "Pokaż": "Anzeigen",
        "Pokaż etykietę": "Beschriftung anzeigen",
        "Pokaż więcej": "Mehr anzeigen",
        "Położenie": "Position",
        "Polski": "Polnisch",
        "Pomniejsz": "Verkleinern",
        "Pomoc": "Hilfe",
        "Ponów": "Wiederholen",
        "Poprzedni slajd": "Vorherige Folie",
        "Powiększ": "Vergrößern",
        "Powiększenie": "Vergrößerung",
        "Powiększenie kanwy": "Leinwandvergrößerung",
        "Powrzarzanie tła": "Hintergrundwiederholung",
        "Powtarzaj": "Wiederholen",
        "Powtarzaj horyzontalnie": "Horizontal wiederholen",
        "Powtarzaj wertykalnie": "Vertikal wiederholen",
        "Pozycja": "Position",
        "Pozycja tła": "Hintergrundposition",
        "Prawy": "Rechts",
        "Prawy dolny": "Unten rechts",
        "Prawy dolny róg": "Untere rechte Ecke",
        "Prawy górny": "Oben rechts",
        "Prawy górny róg": "Obere rechte Ecke",
        "Prezentacja": "Präsentation",
        "Prosty": "Einfach",
        "Przeciągnij {name}": "{name} ziehen",
        "Przejdź wyżej": "Nach oben verschieben",
        "Przekierowanie": "Weiterleitung",
        "Przekreślenie": "Durchgestrichen",
        "Przełącz edycję styli klas": "Klassenstilbearbeitung umschalten",
        "Przełącz obramowanie": "Rahmen umschalten",
        "Przełącz rozwinięcie": "Aufklappen umschalten",
        "Przenieś warstwę": "Ebene verschieben",
        "Przesunięcie": "Verschiebung",
        "Przesunięcie w dół": "Nach unten verschieben",
        "Przesunięcie w górę": "Nach oben verschieben",
        "Przesunięcie w lewo": "Nach links verschieben",
        "Przesunięcie w prawo": "Nach rechts verschieben",
        "Przeźroczystość": "Transparenz",
        "Przycisk": "Schaltfläche",
        "Przykładowy tekst": "Beispieltext",
        "Przypnij do lewej krawędzi": "Am linken Rand fixieren",
        "Przypnij do prawej krawędzi": "Am rechten Rand fixieren",
        "Radio": "Optionsfeld",
        "React": "React",
        "Relatywne": "Relativ",
        "Resetuj wymiary": "Abmessungen zurücksetzen",
        "Równe odstępy": "Gleiche Abstände",
        "Rozbudowany": "Erweitert",
        "Rozbuduj tekst": "Text erweitern",
        "Rozciągnij": "Strecken",
        "Rozmiar": "Größe",
        "Rozmiar strzałek": "Pfeilgröße",
        "Rozmiar tekstu": "Textgröße",
        "Rozmycie": "Unschärfe",
        "Rozstaw liter": "Buchstabenabstand",
        "Saturacja": "Sättigung",
        "Schowaj": "Ausblenden",
        "Sekcja": "Abschnitt",
        "Selektor kolorów": "Farbauswahl",
        "SEO": "SEO",
        "Separator": "Trennlinie",
        "Sepia": "Sepia",
        "SFC": "SFC",
        "Sformatuj poprawnie nazwę klasy": "Klassennamen korrekt formatieren",
        "Skala 100%": "Skalierung 100 %",
        "Skala szarości": "Graustufen",
        "Skrypt": "Skript",
        "Skrypt aktywny": "Skript aktiv",
        "Skrypty": "Skripte",
        "Slajd": "Folie",
        "Slajder": "Slider",
        "Sposób wprowadzania koloru": "Farbeingabemethode",
        "Sposób wprowadzania wartości": "Werteingabemethode",
        "Spread": "Ausbreitung",
        "Środek dolnej krawędzi": "Mitte der unteren Kante",
        "Środek górnej krawędzi": "Mitte der oberen Kante",
        "Środek kontenera": "Mitte des Containers",
        "Środek lewej krawędzi": "Mitte der linken Kante",
        "Środek prawej krawędzi": "Mitte der rechten Kante",
        "Stan": "Status",
        "Stan elementu": "Elementstatus",
        "Statyczne": "Statisch",
        "Strona nie ma jeszcze zawartości": "Die Seite enthält noch keinen Inhalt",
        "Strona zbudowana w Page Builderze": "Mit dem Page Builder erstellte Seite",
        "Strzałki poza slajderem": "Pfeile außerhalb des Sliders",
        "Styl": "Stil",
        "Styl obramowania": "Rahmenstil",
        "Styl tekstu": "Textstil",
        "Style": "Stile",
        "Style nie mogą być puste": "Stile dürfen nicht leer sein",
        "Style tekstu": "Textstile",
        "Szablon": "Vorlage",
        "Szablon aktywny": "Vorlage aktiv",
        "Szablon nie został pobrany": "Vorlage wurde nicht abgerufen",
        "Szablon nie został usunięty": "Vorlage wurde nicht gelöscht",
        "Szablon nie został zapisany": "Vorlage wurde nicht gespeichert",
        "Szablon został usunięty": "Vorlage wurde gelöscht",
        "Szablon został zapisany": "Vorlage wurde gespeichert",
        "Szerokość": "Breite",
        "Szerokość ekranu (px)": "Bildschirmbreite (px)",
        "Szerokość w pikselach": "Breite in Pixeln",
        "Szukaj elementu": "Element suchen",
        "Szukaj elementu…": "Element suchen…",
        "Szukaj w bibliotece": "In der Bibliothek suchen",
        "Szukaj w bibliotece…": "In der Bibliothek suchen…",
        "Tablet": "Tablet",
        "Target": "Ziel",
        "Tej operacji nie można cofnąć.": "Dieser Vorgang kann nicht rückgängig gemacht werden.",
        "Tekst": "Text",
        "Tekst alternatywny": "Alternativtext",
        "Telefon": "Telefon",
        "Tło": "Hintergrund",
        "Tłumaczenie": "Übersetzung",
        "Transformacja": "Transformation",
        "Tryb kreatora": "Assistentenmodus",
        "Tryb układu": "Layoutmodus",
        "Twój adres email": "Ihre E-Mail-Adresse",
        "Twoje imie": "Ihr Vorname",
        "Typ": "Typ",
        "Typ listy": "Listentyp",
        "Typ nagłówka": "Überschriftentyp",
        "Typ przycisku": "Schaltflächentyp",
        "Tytuł": "Titel",
        "Tytuł dla open graph": "Open-Graph-Titel",
        "Tytuł strony": "Seitentitel",
        "Układ": "Layout",
        "Ułóż sekcje i bloki w kreatorze stron": "Ordnen Sie Abschnitte und Blöcke im Seiteneditor an",
        "Ułóż sekcje i bloki w kreatorze stron.": "Ordnen Sie Abschnitte und Blöcke im Seiteneditor an.",
        "Ułożenie elementów": "Anordnung der Elemente",
        "Ułożenie elementów według głównej osi": "Anordnung der Elemente entlang der Hauptachse",
        "Ułożenie elementów według osi poprzecznej": "Anordnung der Elemente entlang der Querachse",
        "Urządzenia": "Geräte",
        "Urządzenie podglądu": "Vorschaugerät",
        "Usuń": "Löschen",
        "Usuń element": "Element löschen",
        "Usuń kolor": "Farbe löschen",
        "Usuń szablon": "Vorlage löschen",
        "Usuń urządzenie": "Gerät löschen",
        "Usuń warstwę": "Ebene löschen",
        "Usuń wymiar": "Abmessung löschen",
        "Usuń zawartość": "Inhalt löschen",
        "Usuń zawartość strony": "Seiteninhalt löschen",
        "Usunąć ten szablon?": "Diese Vorlage löschen?",
        "Utwórz": "Erstellen",
        "Użyj styli zgodnych z CSS3": "CSS3-konforme Stile verwenden",
        "W pionie": "Vertikal",
        "W poziomie": "Horizontal",
        "Warstwy": "Ebenen",
        "Wartość": "Wert",
        "Wartość koloru jest wymagana": "Ein Farbwert ist erforderlich",
        "Wartość w pikselach": "Wert in Pixeln",
        "Wczytywanie biblioteki": "Bibliothek wird geladen",
        "Wczytywanie szablonów": "Vorlagen werden geladen",
        "Wewnętrzny": "Intern",
        "Widget": "Widget",
        "Widget nie został usunięty": "Widget wurde nicht gelöscht",
        "Widget został usunięty": "Widget wurde gelöscht",
        "Widget został zaimportowany": "Widget wurde importiert",
        "Widget został zaktualizowany": "Widget wurde aktualisiert",
        "Widget został zapisany": "Widget wurde gespeichert",
        "Widoczność": "Sichtbarkeit",
        "Wielka litera": "Großbuchstabe",
        "Wiersz": "Zeile",
        "Wiersze": "Zeilen",
        "Włącz pełny ekran": "Vollbild aktivieren",
        "Własne": "Benutzerdefiniert",
        "Własne polecenie": "Benutzerdefinierter Befehl",
        "Własny kod CSS": "Benutzerdefinierter CSS-Code",
        "Własny kod HTML": "Benutzerdefinierter HTML-Code",
        "Własny kod JavaScript": "Benutzerdefinierter JavaScript-Code",
        "Własny kod React": "Benutzerdefinierter React-Code",
        "Własny kod Vue": "Benutzerdefinierter Vue-Code",
        "Własny widget": "Benutzerdefiniertes Widget",
        "Wpisywanie tekstu": "Texteingabe",
        "Wpisz polecenie": "Befehl eingeben",
        "Wpisz tutaj cytat": "Zitat hier eingeben",
        "Wpisz tutaj swój nagłówek": "Überschrift hier eingeben",
        "Wpisz tutaj tekst": "Text hier eingeben",
        "Wprowadź modyfikację": "Änderung eingeben",
        "Wrapper": "Wrapper",
        "Wróć do edycji": "Zurück zur Bearbeitung",
        "Wszystkie sekcje i bloki zostaną usunięte z płótna.": "Alle Abschnitte und Blöcke werden von der Arbeitsfläche entfernt.",
        "Wszystko": "Alles",
        "Wybierz czcionki": "Schriftarten auswählen",
        "Wybierz kolor": "Farbe auswählen",
        "Wybierz opcję": "Option auswählen",
        "Wycentrowanie": "Zentrierung",
        "Wycisz film": "Video stummschalten",
        "Wyczyść": "Leeren",
        "Wyczyść formularz": "Formular leeren",
        "Wyczyść właściwość": "Eigenschaft löschen",
        "Wyczyścić całą stronę?": "Die gesamte Seite leeren?",
        "Wyczyszczenie formularza formularza": "Formular leeren",
        "Wygenerowany tekst": "Generierter Text",
        "Wygląd listy": "Listenansicht",
        "Wymagany": "Erforderlich",
        "Wymiary dokumentu": "Dokumentabmessungen",
        "Wymiary kanwy": "Leinwandabmessungen",
        "Wyrównanie do końca": "Am Ende ausrichten",
        "Wyrównanie do początku": "Am Anfang ausrichten",
        "Wyrównanie tekstu": "Textausrichtung",
        "Wysokość": "Höhe",
        "Wysokość linii": "Zeilenhöhe",
        "Wysokość w pikselach": "Höhe in Pixeln",
        "Wyśrodkowanie": "Zentrieren",
        "Wystąpił błąd podczas próby exportu strony.": "Beim Exportieren der Seite ist ein Fehler aufgetreten.",
        "Wystąpił błąd podczas próby exportu widgetu.": "Beim Exportieren des Widgets ist ein Fehler aufgetreten.",
        "Wystąpił błąd podczas próby importu strony.": "Beim Importieren der Seite ist ein Fehler aufgetreten.",
        "Wystąpił błąd podczas próby importu widgetu.": "Beim Importieren des Widgets ist ein Fehler aufgetreten.",
        "Wystąpił błąd podczas zapisywania kodu CSS": "Beim Speichern des CSS-Codes ist ein Fehler aufgetreten",
        "Wystąpił błąd podczas zapisywania kodu HTML": "Beim Speichern des HTML-Codes ist ein Fehler aufgetreten",
        "Wystąpił błąd podczas zapisywania kodu JavaScript": "Beim Speichern des JavaScript-Codes ist ein Fehler aufgetreten",
        "Wystąpił błąd podczas zapisywania komponentu React": "Beim Speichern der React-Komponente ist ein Fehler aufgetreten",
        "Wyświetl kod": "Code anzeigen",
        "YouTube": "YouTube",
        "Zaawansowany": "Erweitert",
        "Zablokuj": "Sperren",
        "Zaktualizuj": "Aktualisieren",
        "Zamień wymiary": "Abmessungen tauschen",
        "Zamknij": "Schließen",
        "Zanikanie": "Ausblenden",
        "Zaokgrąglenie rogów": "Abgerundete Ecken",
        "Zapętlaj": "Wiederholen",
        "Zapisywanie formularza": "Formular wird gespeichert",
        "Zapisz": "Speichern",
        "Zapisz formularz": "Formular speichern",
        "Zarządzaj urządzeniami": "Geräte verwalten",
        "Zawartość gotowa do edycji": "Inhalt zur Bearbeitung bereit",
        "Zawartość jest gotowa do edycji.": "Der Inhalt ist zur Bearbeitung bereit.",
        "Zawijaj": "Umbrechen",
        "Zawijanie elementow": "Elemente umbrechen",
        "Zaznacz komponent, aby edytować animacje.": "Wählen Sie eine Komponente aus, um Animationen zu bearbeiten.",
        "Zaznaczony": "Ausgewählt",
        "Zaznaczony tekst": "Ausgewählter Text",
        "Zdjęcie": "Foto",
        "Zdjęcie dla open graph": "Open-Graph-Bild",
        "Zewnętrzny": "Extern",
        "Zmień nazwę": "Umbenennen",
        "Zmień rozmiary": "Größe ändern",
        "Zmień wymiary dokumentu": "Dokumentabmessungen ändern",
        "Zoom": "Zoom",
        "Zwykły przycisk": "Standard-Schaltfläche"
    }
};
